import React, { useState } from "react";
import toast from "react-hot-toast";
import { Spinner } from "flowbite-react";

import useSize from "../../../../Utils/useSize/useSize";
import Header from "./Header";
import Backend from "../../../../Backend/Backend";

const backend = await new Backend().init();

export default function UpdateRate(props) {

  const item = props.item;
  const windowSize = useSize();

  const [loading, setLoading] = useState(false);

  const [rate, setRate] = useState("");


  const EditRate = () => {
    if (rate == "" || rate == 0) {
      toast.error("Invalid Rate");
    } else {
      setLoading(true);
      let data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),
        symbol_name: item.symbol,
        rate: rate,
      };

      backend.update_rate(data).then((r) => {
        setLoading(false);
        if (r.error == "False") {
          toast.success(r.message);
          props.reload();
          props.close();
        } else {
          toast.error(r.message);
        }
      });
    }
  };

  return (
    <div
      className="background border primary-border"
      style={{
        width: windowSize[0] / 3,
        height: windowSize[1] / 3,
        borderRadius: 10,
      }}
    >
      <Header item={item} close={props.close} />

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            height: 70,
            marginBottom: 10,
            flexDirection: "column",
            marginTop: 20,
          }}
        >
          <div style={{ display: "flex" }}>
            <label for="sharing" class="label marginright bold flex">
              RATE : {rate}
            </label>
          </div>
          <input
            type="number"
            name="rate"
            id="rate"
            role="presentation"
            autoComplete="new-password"
            style={{ width: windowSize[0] / 4, marginTop: 5 }}
            class="label input bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
            placeholder="Enter Rate"
            value={rate}
            onChange={(e) => {
              setRate(e.target.value);
            }}
          />
        </div>

        <div
          style={{ width: windowSize[0] / 4, marginTop: 10 }}
          className="loginButton lable white"
          onClick={loading ? null : EditRate}
        >
          {loading ? <Spinner size="sm" /> : "UPDATE RATE"}
        </div>
      </div>
    </div>
  );
}
